var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-card"},[_c('p',[_vm._v("Device Uptime Graph")]),_c('canvas',{ref:"uptimeCanvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }